import { useQuery } from "@tanstack/react-query";

import { apiGet, qk } from "@/shared/api";

export function useProfile() {
  return useQuery({
    queryKey: qk.profile(),
    queryFn: ({ signal }) => apiGet("/api/v1/profile", { signal }),
  });
}

/** Код, готовая ссылка и статистика приглашений. Ссылку клиент не собирает. */
export function useReferral() {
  return useQuery({
    queryKey: qk.referral(),
    queryFn: ({ signal }) => apiGet("/api/v1/profile/referral", { signal }),
  });
}

/**
 * Правовой документ. Ручка публичная — токен не отправляется (она в
 * `PUBLIC_PATHS`). `body` приходит в Markdown.
 */
export function useLegal(slug: string) {
  return useQuery({
    queryKey: qk.legal(slug),
    queryFn: ({ signal }) => apiGet("/api/v1/legal/{slug}", { params: { slug }, signal }),
    // Документы меняются раз в месяцы — перезапрашивать их при каждом
    // возврате на экран незачем.
    staleTime: 60 * 60 * 1000,
  });
}
